// SAB-555: official rules for the free welcome-card promotion (free + random =
// promotional chance mechanic / sweepstakes-adjacent; requires published rules +
// equal-odds disclosure).
//
// ⚠️ PENDING COUNSEL — this rules text is a plain-language DRAFT. Dan must review and
// bless the final wording (running-list item). Do NOT remove this flag or treat this
// as final legal copy until counsel signs off.
import { Card, CardContent } from '@/components/ui/card';
import MarketingLayout from '@/components/shared/MarketingLayout';

const POOL = [
  'Film Room', 'Pick Six Party', 'Goal Line Stand', 'Pass Interference', 'Prevent Defense',
  'Personal Foul', 'Punt Return Fumble', 'Rain Delay', 'Unsportsmanlike Conduct',
];

export default function PromoRules() {
  return (
    <MarketingLayout>
      <div className="mx-auto max-w-3xl px-4 py-10">
        <h1 className="font-display font-extrabold text-3xl text-foreground mb-2">Welcome Card Offer — Official Rules</h1>
        <p className="text-sm text-muted-foreground mb-6">No purchase necessary. Void where prohibited. Draft pending final legal review.</p>

        <Card className="bg-card border-border">
          <CardContent className="p-6 space-y-5 text-sm leading-relaxed text-muted-foreground">
            <section>
              <h2 className="text-foreground font-semibold mb-1">1. Sponsor</h2>
              <p>This promotion is offered by Sabotage Fantasy LLC ("Sponsor").</p>
            </section>
            <section>
              <h2 className="text-foreground font-semibold mb-1">2. Eligibility</h2>
              <p>Open to individuals who are <span className="text-foreground">18 or older (19+ in Nebraska)</span>, are physically located in a state where Sabotage Fantasy real-money contests are offered, and who create a new Sabotage Fantasy account. Employees of the Sponsor and their immediate families are not eligible.</p>
            </section>
            <section>
              <h2 className="text-foreground font-semibold mb-1">3. How to participate — no purchase necessary</h2>
              <p>Create a new account and join or create your first NFL league. Upon joining your first league, one (1) sabotage card is automatically added to that team's inventory. <span className="text-foreground">No purchase is necessary</span> to create an account, join a free-to-play league, or receive the card.</p>
            </section>
            <section>
              <h2 className="text-foreground font-semibold mb-1">4. The prize — one random Rare card, equal odds</h2>
              <p>The card is selected at random, with <span className="text-foreground">equal odds (1 in 9)</span>, from the following nine Rare single-matchup sabotage cards:</p>
              <ul className="grid grid-cols-1 sm:grid-cols-3 gap-x-4 gap-y-1 mt-2 list-disc pl-5 text-foreground/90">
                {POOL.map((c) => <li key={c}>{c}</li>)}
              </ul>
              <p className="mt-2">Selection is performed server-side; participants cannot choose or influence which card they receive.</p>
            </section>
            <section>
              <h2 className="text-foreground font-semibold mb-1">5. Limit</h2>
              <p>Limit <span className="text-foreground">one (1) welcome card per account</span>, regardless of how many leagues you join or create. The card is usable per the standard sabotage rules of the league it is granted in.</p>
            </section>
            <section>
              <h2 className="text-foreground font-semibold mb-1">6. General</h2>
              <p>The card has no cash value and is an in-game item only. Sponsor reserves the right to modify, suspend, or end this promotion at any time. This offer is independent of any purchase and is provided on equal terms to all eligible new accounts.</p>
            </section>
          </CardContent>
        </Card>
      </div>
    </MarketingLayout>
  );
}
